module.exports = {"A__FFFFFFFF":"#ffffffff","A__FF757575":"#ff757575","A__FFFF0000":"#ffff0000","A__FFD7D7D7":"#ffd7d7d7","A__FFEE0000":"#ffee0000","A__19BBBBBB":"#19bbbbbb","A__00FFFFFF":"#00ffffff","A__FFF7F7F7":"#fff7f7f7"}


//////////////////
// WEBPACK FOOTER
// ./res/color.json
// module id = 5
// module chunks = 0